import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VueAwesomeSwiper from "vue-awesome-swiper";
import Vodal from "vodal";
import getColumns from "./assets/js/Common";
import filters from "./assets/js/Filters";
Object.keys(filters).forEach((k) => Vue.filter(k, filters[k]));

import "swiper/dist/css/swiper.css";
import "vodal/common.css";
import "vodal/rotate.css";
import "./assets/scss/wap.scss";

import { interact } from "fire-wind-water";

Vue.component(Vodal.name, Vodal);

Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
Vue.prototype.getColumns = getColumns;
Vue.mixin({
  methods: {
    pxOrVw(value) {
      let newValue;
      if (interact.isMobile) {
        if (value > 2) {
          newValue = value / 7.5 + "vw";
        } else {
          newValue = "1px";
        }
      } else {
        newValue = value + "px";
      }
      return newValue;
    },
  },
});
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
